var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_vm._l((_vm.getSourceList),function(source,sourceIdx){return _c('source',{key:sourceIdx,attrs:{"srcset":source.srcset,"media":source.media,"type":source.type}})}),_vm._v(" "),_c('img',{class:_vm.imgClass,attrs:{"src":_vm.getMainSource,"alt":_vm.alt,"height":_vm.height,"width":_vm.width,"loading":_vm.loading,"title":_vm.alt}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }